import { posToDOMRect } from "@tiptap/core";
import { SmileSmall } from "@wix/wix-ui-icons-common";
import { quickActionsModalSections } from "./../ricos-types/index.js";
import { getTipTapExtensions } from "./extension.js";
import { getAddButtons } from "./getAddButtons.js";
import EmojiInsertModal from "./modals/InsertModal.js";
import { EMOJI_TYPE, emojiModals } from "./types.js";
const pluginEmoji = (config) => {
  return {
    config: { ...config },
    type: EMOJI_TYPE,
    tiptapExtensions: getTipTapExtensions(),
    getAddButtons: (config2, services) => getAddButtons(config2, services),
    getQuickActions: () => [
      {
        id: "emoji",
        title: "QuickActionsPlugin_ActionTitle_Emoji",
        icon: SmileSmall,
        section: quickActionsModalSections.FormatLayout,
        tags: ["smiley", "emoticon", "face", "reaction", "emotions", "symbol"],
        command: ({ modalService, editor }) => modalService.togglePluginPanel({
          id: emojiModals.insert,
          Component: EmojiInsertModal,
          componentProps: {},
          isMobile: false,
          positioning: {
            referenceElement: {
              getBoundingClientRect: () => posToDOMRect(
                editor.view,
                editor.view.state.selection.from,
                editor.view.state.selection.to
              )
            },
            placement: "bottom-end"
          },
          onClickOutside: () => modalService.closeModal(emojiModals.insert)
        })
      }
    ],
    __exports: {
      InsertModal: EmojiInsertModal
    }
  };
};
export {
  pluginEmoji
};
//# sourceMappingURL=editor.js.map
